import { getEnv } from 'common-nextjs';

/**
 * Amplitude's script code without loading the actual script.
 * This sets up capturing events until the real script loads.
 *
 * See also: AmplitudeScript.tsx
 */
export function setupAmplitudeLocalCapture() {
  if (window.amplitude) return;

  let n: any = window.amplitude || { _q: [], _iq: {} };

  function s(e, t) {
    e.prototype[t] = function () {
      if (getEnv() !== 'production') {
        console.log(
          `[Amplitude Local] ${e.name || 'Unknown'}.${t} called with args:`,
          Array.prototype.slice.call(arguments, 0),
        );
      }
      this._q.push([t].concat(Array.prototype.slice.call(arguments, 0)));
      return this;
    };
  }

  let o = function (this: any) {
    this._q = [];
    return this;
  };
  let a = [
    'add',
    'append',
    'clearAll',
    'prepend',
    'set',
    'setOnce',
    'unset',
    'preInsert',
    'postInsert',
    'remove',
  ];
  for (let c = 0; c < a.length; c++) {
    s(o, a[c]);
  }
  n.Identify = o;
  let u = function (this: any) {
    this._q = [];
    return this;
  };
  let l = [
    'setProductId',
    'setQuantity',
    'setPrice',
    'setRevenueType',
    'setEventProperties',
  ];
  for (let p = 0; p < l.length; p++) {
    s(u, l[p]);
  }
  n.Revenue = u;
  let d = [
    'init',
    'logEvent',
    'logRevenue',
    'setUserId',
    'setUserProperties',
    'setOptOut',
    'setVersionName',
    'setDomain',
    'setDeviceId',
    'enableTracking',
    'setGlobalUserProperties',
    'identify',
    'clearUserProperties',
    'setGroup',
    'logRevenueV2',
    'regenerateDeviceId',
    'groupIdentify',
    'onInit',
    'logEventWithTimestamp',
    'logEventWithGroups',
    'setSessionId',
    'resetSessionId',
  ];
  function v(e) {
    function t(t) {
      e[t] = function () {
        if (getEnv() !== 'production') {
          console.log(
            `[Amplitude Local] ${t} called with args:`,
            Array.prototype.slice.call(arguments, 0),
          );
        }
        e._q.push([t].concat(Array.prototype.slice.call(arguments, 0)));
      };
    }

    for (let n = 0; n < d.length; n++) {
      t(d[n]);
    }
  }

  v(n);
  n.getInstance = function (e) {
    e = (!e || e.length === 0 ? '$default_instance' : e).toLowerCase();
    if (!Object.prototype.hasOwnProperty.call(n._iq, e)) {
      if (getEnv() !== 'production') {
        console.log(`[Amplitude Local] Creating new instance: ${e}`);
      }
      n._iq[e] = { _q: [] };
      v(n._iq[e]);
    }
    return n._iq[e];
  };

  window.amplitude = n;
  const apiKey = getEnv('AMPLITUDE_API_KEY');
  if (apiKey) {
    window.amplitude.getInstance().init(apiKey);
  }
}
